import React, { Component } from 'react';

class CardBrandMobile extends Component {
  constructor(props) {
    super(props);
    this.selectBrand = this.selectBrand.bind(this);
  }

  selectBrand = (i) => {
    this.props.selectPaymentCreditCard(2);
    this.props.selectCreditCardBrand(i);
  };

  render() {
    return (
      <div
        className="area-cartoes flex mobile"
        style={{ display: this.props.stepDisplayCreditCard !== 1 && !this.props.mobile ? 'none' : 'block' }}
      >
        <h4>Selecione a bandeira do seu cartão</h4>

        <div className="area-bandeiras">
          <ul className="lista-cartoes radio-input">
            {this.props.brands.map((card, i) => (
              <li className="" key={i} onClick={() => this.selectBrand(i)}>
                <input
                  type="radio"
                  id={'card' + i}
                  name="c1"
                  checked={card.selected}
                  onChange={() => this.selectBrand(i)}
                />
                <label htmlFor={'card' + i}>
                  <img src={`/assets/images/home/home/cards/v2/${card.brand_name}.svg`} alt="" />
                  <span className="cartao-titulo">
                    {card.brand_name} <br />
                    {card.parcels >= 1 && <small>Até {card.parcels}x sem juros</small>}
                  </span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default CardBrandMobile;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/CreditCard/CardBrandMobile.jsx